import React from 'react';
import PropTypes from "prop-types";
import { formatTime } from '../../utils/dateTimeUtils';

const DepartureTime = ({ fromTime }, context) => {

    if (!fromTime) return null;

    const formattedTime = fromTime.length > 12 ? formatTime(fromTime.substring(11)) : formatTime(fromTime);

    return (
        <div>
            {context.t('time')}: {formattedTime}
        </div>
    );
};

DepartureTime.contextTypes = {
    t: PropTypes.func.isRequired
}

export default DepartureTime;